module.exports = __webpack_public_path__ + "static/media/GQ.3c96f718.svg";